import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { seconds: Number }

  connect() {
    this.remaining = this.secondsValue
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  tick() {
    if (this.remaining <= 0) {
      clearInterval(this.timer)
      this.element.textContent = '0:00'
      // Redirect when time expires
      window.location.reload()
      return
    }

    const minutes = Math.floor(this.remaining / 60)
    const seconds = this.remaining % 60
    this.element.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`
    this.remaining--
  }
}
